"use client";
import * as React from "react";
const SvgExpandMoreFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 8", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.59.3 6 4.88 1.41.3 0 1.7l6 6 6-6z" }));
export {
  SvgExpandMoreFilled as default
};
